import React from "react";
import MaInput from "../../../../Components/UI/ma-input";
import { Badge, InputAdornment, MenuItem, Tab, Tabs } from "@mui/material";
import { LuSearch } from "react-icons/lu";
import { PRODUCT_FILTER_MENU_PROPS } from "../products/product-filter-menu-styles";

const TAB_DEF = [
  { key: "all", label: "All", badge: false },
  { key: "new", label: "New", badge: true },
  { key: "processing", label: "Processing", badge: true },
  { key: "ready_pickup", label: "Ready for Pick-up", badge: false },
  { key: "out_delivery", label: "Out for Delivery", badge: false },
  { key: "delivered", label: "Delivered", badge: false },
  { key: "failed_delivery", label: "Failed Delivery", badge: false },
  { key: "cancelled", label: "Cancelled", badge: false },
];

const STATUS_MENU_LABELS = {
  all: "All",
  new: "New Order",
  processing: "Processing",
  ready_pickup: "Ready for Pick-up",
  out_delivery: "Out for Delivery",
  delivered: "Delivered",
  failed_delivery: "Failed Delivery",
  cancelled: "Cancelled",
};

const FILTER_SELECT_PROPS = {
  MenuProps: PRODUCT_FILTER_MENU_PROPS,
};

const tabSx = {
  borderBottom: "1px solid #ECECEC",
  minHeight: 48,
  "& .MuiTabs-indicator": {
    backgroundColor: "#18181B",
    height: 2,
    borderRadius: "999px",
  },
  "& .MuiTab-root": {
    textTransform: "none",
    fontSize: "13px",
    fontWeight: 600,
    minHeight: 48,
    py: 1.25,
    px: 2,
    color: "#9CA3AF",
    "&:hover": { color: "#6B7280" },
    "&.Mui-selected": { color: "#18181B" },
  },
};

function TabLabel({ label, count, showBadge }) {
  if (!showBadge || count == null || count === 0) {
    return <span>{label}</span>;
  }
  return (
    <Badge
      badgeContent={count}
      sx={{
        "& .MuiBadge-badge": {
          fontSize: "10px",
          fontWeight: 700,
          minWidth: 18,
          height: 18,
          padding: "0 5px",
          bgcolor: "#2E1834",
          color: "#fff",
        },
      }}
    >
      <span className="pr-1">{label}</span>
    </Badge>
  );
}

const statusSelectProps = {
  ...FILTER_SELECT_PROPS,
  renderValue: (selected) => {
    if (!selected || selected === "all") {
      return <span className="text-[#717171]">Status</span>;
    }
    return STATUS_MENU_LABELS[selected] ?? selected;
  },
};

export function OrdersFilterBar({
  activeTab,
  onTabChange,
  tabCounts,
  search,
  onSearchChange,
  category,
  onCategoryChange,
}) {
  return (
    <div className="space-y-4 md:space-y-5">
      <div className="flex flex-col gap-3 md:flex-row md:items-center md:gap-4">
        <div className="w-full md:min-w-0 md:flex-1">
          <MaInput
            fullWidth
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Search products..."
            borderColor="#E5E7EB"
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    <LuSearch className="text-[20px] text-[#9CA3AF]" />
                  </InputAdornment>
                ),
              },
            }}
          />
        </div>

        <div className="grid grid-cols-2 gap-3 md:hidden">
          <div className="min-w-0">
            <MaInput
              select
              fullWidth
              value={activeTab}
              onChange={(e) => onTabChange(e.target.value)}
              SelectProps={statusSelectProps}
              borderColor="#E5E7EB"
            >
              <MenuItem value="all">All</MenuItem>
              {TAB_DEF.filter((t) => t.key !== "all").map((t) => (
                <MenuItem key={t.key} value={t.key}>
                  {STATUS_MENU_LABELS[t.key] ?? t.label}
                </MenuItem>
              ))}
            </MaInput>
          </div>
          <div className="min-w-0">
            <MaInput
              select
              fullWidth
              value={category}
              onChange={(e) => onCategoryChange(e.target.value)}
              SelectProps={FILTER_SELECT_PROPS}
              borderColor="#E5E7EB"
            >
              <MenuItem value="">Category</MenuItem>
              <MenuItem value="accessories">Accessories</MenuItem>
              <MenuItem value="fashion">Fashion</MenuItem>
              <MenuItem value="gadget">Gadget</MenuItem>
            </MaInput>
          </div>
        </div>

        <div className="hidden min-w-[160px] md:block md:w-[200px] md:shrink-0">
          <MaInput
            select
            fullWidth
            value={category}
            onChange={(e) => onCategoryChange(e.target.value)}
            SelectProps={FILTER_SELECT_PROPS}
            borderColor="#E5E7EB"
          >
            <MenuItem value="">Category</MenuItem>
            <MenuItem value="accessories">Accessories</MenuItem>
            <MenuItem value="fashion">Fashion</MenuItem>
            <MenuItem value="gadget">Gadget</MenuItem>
          </MaInput>
        </div>
      </div>

      <Tabs
        value={activeTab}
        onChange={(_, value) => onTabChange(value)}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        className="hidden md:block"
        sx={tabSx}
      >
        {TAB_DEF.map((t) => (
          <Tab
            key={t.key}
            value={t.key}
            label={
              <TabLabel
                label={t.label}
                showBadge={t.badge}
                count={
                  t.key === "new"
                    ? tabCounts?.new
                    : t.key === "processing"
                      ? tabCounts?.processing
                      : undefined
                }
              />
            }
          />
        ))}
      </Tabs>
    </div>
  );
}
